import type {
  ClientMediaItem,
  ClientPerson,
  ClientPersonReference
} from '@DigitaleDoerfer/digitale-doerfer-api';

import type { AvatarTextFallback } from '@/features/media/types/avatar';

export const getPersonAvatarPicture = (
  person: ClientPerson | ClientPersonReference
): ClientMediaItem | undefined => {
  const deleted = person.deleted ?? false;
  const blocked = person.filterStatus === 'BLOCKED';
  return deleted || blocked ? undefined : person.profilePicture;
};

export const getPersonAvatarTextFallback = (
  person: ClientPerson | ClientPersonReference
): AvatarTextFallback => {
  const firstName = person.firstName ?? '';
  const lastName = person.lastName ?? '';
  const deleted = person.deleted ?? false;
  return deleted ? { shortName: '?' } : { firstName, lastName };
};
